export default {
  name: 'SideNavItem',
  template: '#side-nav-item-template',
  data () {
    return {}
  },
  props: ['route', 'text', 'headLink']
}



// WEBPACK FOOTER //
// ./src/components/side-nav/SideNavItem.js